import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./member.scss";

function Member() {
  return (
    <div>
      <div className="menu-atas">
        <ul>
          <NavLink
            style={{ textDecoration: "none" }}
            to={"/homepage/members/"}
            className={({ isActive }) =>
              isActive ? "active-header-member" : "non-active-header-member"
            }
          >
            <li>Member List</li>
          </NavLink>
          <NavLink
            style={{ textDecoration: "none" }}
            to={"/homepage/members/chekin/"}
            className={({ isActive }) =>
              isActive ? "active-header-member" : "non-active-header-member"
            }
          >
            <li>Checkin Guest</li>
          </NavLink>
          <NavLink
            style={{ textDecoration: "none" }}
            to={"/homepage/members/new-member/"}
            className={({ isActive }) =>
              isActive ? "active-header-member" : "non-active-header-member"
            }
          >
            <li>New Member</li>
          </NavLink>
          <NavLink
            style={{ textDecoration: "none" }}
            to={"/homepage/members/exp/"}
            className={({ isActive }) =>
              isActive ? "active-header-member" : "non-active-header-member"
            }
          >
            <li>Expired Member</li>
          </NavLink>
        </ul>
      </div>
      <Outlet />
    </div>
  );
}

export default Member;
